module.exports = __webpack_public_path__ + "7459d478.png";